import { useIntl } from '@capsicum/common';
import { type TourProps } from '@reactour/tour';
import styled from 'styled-components';

import { useTutorialUtilities } from '../../hooks/tutorial/useTutorialUtilities';
import { Button } from '../../ui/atoms/buttons/button/Button';

export const PreviousButton: TourProps['prevButton'] = ({ currentStep }) => {
	const { $t } = useIntl();
	const { previousStep } = useTutorialUtilities();

	return (
		currentStep > 0 && (
			<Button
				buttonElementStyle={{ height: 0, padding: 0 }}
				color="brand"
				style={{ padding: 0 }}
				testID="tutorial-back"
				text={$t('global.button.back')}
				variant="text"
				onClick={previousStep}
			/>
		)
	);
};

export const NextButton: TourProps['nextButton'] = () => {
	const { $t } = useIntl();
	const { isLastStep, nextStep } = useTutorialUtilities();

	return (
		<S.NextButtonStyled
			buttonElementStyle={{ height: 0, padding: 0 }}
			color="brand"
			testID="tutorial-next"
			text={$t(isLastStep ? 'global.button.gotIt' : 'global.button.next')}
			variant="text"
			onClick={nextStep}
		/>
	);
};

namespace S {
	export const NextButtonStyled = styled(Button)`
		margin-left: ${({ theme }) => theme.spacings.large};
	`;
}
